//
// ============================================================================
// IMPORTS
// ============================================================================
//

import { useAuthClient } from "../../lib/auth-client";
import { ProdCoreClient } from "../../services/api/clients/prodCoreClient";

//
// ============================================================================
// STATE (Module-Level Singleton)
// ============================================================================
//

let cachedClient: ProdCoreClient | null = null;
let cachedToken: string | null = null;

//
// ============================================================================
// COMPOSABLE
// ============================================================================
//

/**
 * Production API Client Composable
 *
 * Provides singleton access to ProdCoreClient with token-based caching.
 * Ensures only one API client instance exists per authentication token.
 *
 * Responsibilities:
 * - Create and cache ProdCoreClient instance
 * - Recreate client when auth token changes (login/logout/refresh)
 * - Use current JWT token for all API requests
 * - Provide base URL from runtime configuration
 *
 * @returns ProdCoreClient instance with current auth token
 */
export const useProdClient = async () => {
  const config = useRuntimeConfig();
  const currentToken = useAuthClient().getToken();

  // Only create new client if token changed
  if (!cachedClient || cachedToken !== currentToken) {
    cachedClient = new ProdCoreClient(config.public.API_BASE_URL, currentToken as string);
    cachedToken = currentToken;
  }

  return cachedClient;
};
